import { Injectable } from '@angular/core';

@Injectable()
export class AppInfoService {
  constructor() {}

  public get title() {
    return '滿意度問卷';
  }

  public get currentYear() {
    return new Date().getFullYear();
  }
}
